import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helpersNumbers from "../../../helpers/numbers";
import sites from "./Sites";
import StateSiteUserPublisher from "./StateSiteUserPublisher";

export default function AllSite() {
  return (
    <>
      <Sidebar activeItem="all-my-site-menu" />

      <div className="content-wrapper">
        <TitleBar title="سایت ها نمایش دهنده شما" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-warning">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      سایت شما در صورتی فعال میشود که اولین جایگاه تبلیغاتی برای
                      آن سایت توسط شما اضافه شود و اپراتور آنرا تایید کند.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="pb-2">
                <Link to="/site/add" className="btn btn-success">
                  <span className="pl-2">
                    <i className="fa fa-plus"> </i>
                  </span>
                  <span>اضافه کردن سایت نمایش دهنده</span>
                </Link>
              </div>
              <div className="table-responsive">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره</td>
                      <td>آدرس</td>
                      <td>وضعیت</td>
                      <td>حالت</td>
                      <td>تاریخ درج</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {sites.map((userSitePublisher, index) => {
                      let classNameBadgeType = "";
                      switch (userSitePublisher.status) {
                        case StateSiteUserPublisher.statusSiteUserPublisher
                          .PENDING:
                          classNameBadgeType = "warning";
                          break;
                        case StateSiteUserPublisher.statusSiteUserPublisher
                          .CONFIRM:
                          classNameBadgeType = "success";
                          break;
                        case StateSiteUserPublisher.statusSiteUserPublisher
                          .REJECT:
                          classNameBadgeType = "danger";
                          break;
                      }

                      return (
                        <tr>
                          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                          <td>
                            {helpersNumbers.toPersianNum(userSitePublisher.ID)}
                          </td>
                          <td className="text-left">
                            <a target="_blank" href={userSitePublisher.url}>
                              {userSitePublisher.url}
                            </a>
                          </td>
                          <td>
                            <span
                              className={`badge  badge-${classNameBadgeType}`}
                            >
                              {userSitePublisher.status}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`
                        badge badge-${
                          userSitePublisher.active ? "success" : "danger"
                        }
                        `}
                            >
                              {userSitePublisher.active ? "فعال" : "غیرفعال"}
                            </span>
                          </td>
                          <td>{userSitePublisher.created_at}</td>
                          <td>
                            <Link
                              className="btn btn-info"
                              to={`/site/info/${userSitePublisher.ID}`}
                            >
                              <i className="fa fa-info"></i>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
